module.exports = __webpack_public_path__ + "img/about-icon2.83470cb6.png";